import React from "react";
import { Wallet } from "lucide-react";

export default function WalletCard({ profile, qr }) {
  return (
    <section
      data-testid="wallet-card"
      className="bg-white border border-[#E5E2DC] rounded-2xl p-6 sm:p-8 print:break-inside-avoid"
    >
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-2 inline-flex items-center gap-1.5">
        <Wallet size={11} /> Wallet-size emergency list · fold & carry
      </div>
      <p className="text-xs text-[#5C6B62] mb-4">
        Print at 100% scale, fold in half, and keep in wallet or purse.
      </p>

      <div className="mx-auto max-w-[3.5in] border-2 border-[#1C2B23] rounded-lg p-4 bg-[#FFFBF3]">
        <div className="text-center border-b border-[#1C2B23] pb-2 mb-2">
          <div className="text-[10px] uppercase tracking-wider font-semibold text-[#1C2B23]">
            Emergency medication list
          </div>
          <div className="text-sm font-semibold text-[#1C2B23]">{profile.name}</div>
          <div className="text-[10px] text-[#5C6B62]">
            Updated {new Date().toLocaleDateString()}
          </div>
        </div>
        <ol className="text-[11px] space-y-1.5 leading-tight">
          {profile.meds.map((m) => (
            <li key={m.id} className="flex gap-2">
              <span className="font-semibold text-[#1C2B23] flex-shrink-0">•</span>
              <span className="text-[#1C2B23]">
                <span className="font-semibold">{m.generic_name}</span>
                {m.brand_name && ` (${m.brand_name})`}
                {" "}
                <span className="font-semibold text-[#2B5339]">{m.strength}</span>
                {m.times?.length ? ` — ${m.times.join(", ")}` : ""}
              </span>
            </li>
          ))}
        </ol>
        <div className="mt-3 pt-2 border-t border-[#1C2B23] flex items-center gap-2">
          <div className="flex-1 text-[9px] text-[#5C6B62] leading-tight">
            Poison Control (US): 1-800-222-1222 · Emergency: 911
            {qr && (
              <div className="mt-0.5 font-semibold text-[#1C2B23]">
                Scan for full card →
              </div>
            )}
          </div>
          {qr && (
            <img
              data-testid="wallet-card-qr"
              src={qr}
              alt="QR code — opens this medication card"
              className="w-12 h-12 flex-shrink-0"
            />
          )}
        </div>
      </div>
    </section>
  );
}
